
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/apple/[...params]",
      function () {
        return require("private-next-pages/shop/apple/[...params].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/apple/[...params]"])
      });
    }
  